import { PeopleOutline } from '@mui/icons-material';
import { CardContainer } from 'finara-components';

import { DepartmentData } from '@/data/admin/dashboard/dashboardData';

interface DepartmentDistributionProps {
  departments: DepartmentData[];
}

export const DepartmentDistribution: React.FC<DepartmentDistributionProps> = ({ departments }) => {
  return (
    <CardContainer>
      {/* Header */}
      <div className="flex items-center gap-2 mb-6">
        <PeopleOutline className="text-purple-600" fontSize="medium" />
        <h3 className="text-sm font-semibold text-brand-white">Distribución por Departamento</h3>
      </div>

      {/* Department List */}
      <div className="grid grid-cols-2 md:!grid-cols-4 gap-6">
        {departments.map(dept => (
          <div key={dept.name} className="text-center">
            <div className="text-[21px] font-semibold text-brand-white">{dept.employeeCount}</div>
            <div className="text-[12.25px] text-muted">{dept.name}</div>
            <div className="text-[10.5px] text-muted">
              ${(dept.monthlyAmount / 1000).toFixed(0)}K/mes
            </div>
          </div>
        ))}
      </div>
    </CardContainer>
  );
};
